/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_Th2Inputs */

const en_mk_cmp_linear_th2 = /** @type {(inputs: Mk_Cmp_Linear_Th2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None; it relies on Slack alongside.`)
};

const id_mk_cmp_linear_th2 = /** @type {(inputs: Mk_Cmp_Linear_Th2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada; mengandalkan Slack di sebelahnya.`)
};

/**
* | output |
* | --- |
* | "None; it relies on Slack alongside." |
*
* @param {Mk_Cmp_Linear_Th2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_th2 = /** @type {((inputs?: Mk_Cmp_Linear_Th2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_Th2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_th2(inputs)
	return en_mk_cmp_linear_th2(inputs)
});